import React from "react";

import { ARCHIVE_CONFIRM_MESSAGE, ARCHIVE_AMENITY_CONFIRM_MESSAGE } from "../Bookings";
import {
    POPULATE_CATEGORY_DATA,
    POPULATE_COMBINED_TABLE_DATA,
    POPULATE_COMBINED_TABLE_META,
    SET_ARCHIVE_AMENITY_MODAL_MESSAGE,
    SET_ARCHIVE_AMENITY_MODAL_OPEN,
    SET_ARCHIVE_MODAL_MESSAGE,
    SET_ARCHIVE_MODAL_OPEN,
    SET_DELETE_CATEGORY_MODAL_OPEN,
    SET_IS_LOADING,
    SET_REACTIVATE_MODAL_OPEN,
    SET_SEARCH_BLOCKS,
    SET_SEARCH_TEXT
} from "./BookingsAdminActions";

export const initialState = {
    categories: [],
    combinedTableList: [],
    combinedTableMeta: {},
    archiveModalOpen: false,
    archiveModalMessage: ARCHIVE_CONFIRM_MESSAGE,
    archiveAmenityModalOpen: false,
    archiveAmenityModalMessage: ARCHIVE_AMENITY_CONFIRM_MESSAGE,
    reactivateModalOpen: false,
    deleteCategoryModalOpen: false,
    searchText: '',
    searchBlocks: [],
    isLoading: false,
};

export const bookingsAdminLocalReducer = (state = initialState, action) => {
    switch (action.type) {
        case POPULATE_CATEGORY_DATA:
            return {
                ...state,
                categories: action.payload.data
            }

        case POPULATE_COMBINED_TABLE_DATA:
            return {
                ...state,
                combinedTableList: action.payload.data
            }

        case POPULATE_COMBINED_TABLE_META:
            return {
                ...state,
                combinedTableMeta: action.payload.data
            }

        case SET_ARCHIVE_MODAL_OPEN:
            return {
                ...state,
                archiveModalOpen: action.payload.data
            }

        case SET_ARCHIVE_MODAL_MESSAGE:
            return {
                ...state,
                archiveModalMessage: action.payload.data
            }

        case SET_REACTIVATE_MODAL_OPEN:
            return {
                ...state,
                reactivateModalOpen: action.payload.data
            }

        case SET_ARCHIVE_AMENITY_MODAL_OPEN:
            return {
                ...state,
                archiveAmenityModalOpen: action.payload.data
            }

        case SET_ARCHIVE_AMENITY_MODAL_MESSAGE:
            return {
                ...state,
                archiveAmenityModalMessage: action.payload.data
            }

        case SET_SEARCH_TEXT:
            return {
                ...state,
                searchText: action.payload.data
            }

        case SET_SEARCH_BLOCKS:
            return {
                ...state,
                searchBlocks: action.payload.data
            }

        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
            
        case SET_DELETE_CATEGORY_MODAL_OPEN:
            return {
                ...state,
                deleteCategoryModalOpen: action.payload
            }
        default:
            break;
    }
    return state;
}
